module.exports = __webpack_public_path__ + "media/images/www/logo_dark_teal-6e9f824a057952dac2fef6b3674389b5.svg";